module.exports = __webpack_public_path__ + "img/cusromerLogo2.f2e42407.png";